import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Method', path: '/method' },
    { name: 'Collection', path: '/product' },
    { name: 'Education', path: '/education' },
    { name: 'Service', path: '/clinical-services' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-warmWhite/95 backdrop-blur-md shadow-soft' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 lg:px-14">
        <div className="flex items-center justify-between h-18">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center shrink-0">
              <img
                src="https://static.readdy.ai/image/296ab9838c8a2f1e2b2bac03a156c5b2/547be4984668e7b5c47ec2a331e97ec6.png"
                alt="Vionne Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <h1>
              <span className={`font-display text-lg font-medium tracking-[0.08em] transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-white'}`}>
                Vionne Clinical Atelier
              </span>
            </h1>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[10px] font-sans font-medium tracking-[0.15em] uppercase transition-colors duration-300 cursor-pointer ${
                  isScrolled
                    ? location.pathname === link.path ? 'text-charcoal' : 'text-textGray hover:text-charcoal'
                    : location.pathname === link.path ? 'text-white' : 'text-white/65 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <button
            onClick={() => window.REACT_APP_NAVIGATE('/booking')}
            className={`hidden md:block px-6 py-2 text-[10px] font-sans font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase ${
              isScrolled
                ? 'bg-bronze text-white hover:bg-softGold'
                : 'bg-white/90 text-charcoal hover:bg-white'
            }`}
          >
            Reserve
          </button>

          <button
            className={`md:hidden cursor-pointer ${isScrolled ? 'text-charcoal' : 'text-white'}`}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i className={`${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-warmWhite/98 backdrop-blur-md border-t border-warmGray/20">
          <div className="px-8 py-8 space-y-5">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-sm font-sans font-medium tracking-wide cursor-pointer ${
                  location.pathname === link.path ? 'text-charcoal' : 'text-textGray'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/booking')}
              className="w-full mt-4 px-6 py-3.5 bg-bronze text-white text-[13px] font-sans font-semibold rounded-full whitespace-nowrap cursor-pointer tracking-wide"
            >
              Reserve
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
